import React, { Suspense, lazy, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../assets/CulturalHeritage/styles/styles.css";

const PreviousBookings = lazy(() => import("../../src/pages/CulturalHeritage/PreviousBooking/PreviousBookings"));
const Home = lazy(() => import("../../src/pages/CulturalHeritage/Home/index"));
const HeritagePage = lazy(() => import("../../src/pages/CulturalHeritage/Heritage/HeritagePage"));
const HeritageBooking = lazy(() => import("../../src/pages/CulturalHeritage/Heritage/HeritageBooking"));
const PaymentPage = lazy(() => import("../../src/pages/CulturalHeritage/PaymentPage/PaymentPage"));
const BookingFormPage = lazy(() => import("../../src/pages/CulturalHeritage/BookingFormPage/BookingFormPage"));
const BookingDetailsPage = lazy(() => import("../../src/pages/CulturalHeritage/BookingFormPage/BookingDetailsPage"));
const ExpiredPage = lazy(() => import("../../src/pages/CulturalHeritage/ExpiredPage/ExpiredPage"));
const SessionWrapper = lazy(() => import("../../src/pages/CulturalHeritage/ExpiredPage/SessionWrapper"));
const Transactions = lazy(() => import("../../src/pages/CulturalHeritage/Transactions/transactions"));
const NotFound = lazy(() => import("../../src/pages/CulturalHeritage/PageNotFound/NotFound"));

const CulturalHeritageRoutes = () => {
  const {checksum} = useSelector((state) => state.culturalHeritageReducer);
  const { i18n } = useTranslation();
  useEffect(() => {
    if (checksum?.acceptLanguage) {
      i18n.changeLanguage(checksum?.acceptLanguage);
    }
  }, [checksum?.acceptLanguage, i18n]);

  return (
    <>
      <Suspense fallback={<div className="loading"></div>}>
        <Routes>
          <Route
            path="cb/wa/merchant/ondc/cultural-heritage/booking/:checksum"
            element={<SessionWrapper />}
          >
            <Route index element={<Home />} />
            <Route path="heritages" element={<HeritagePage />} />
            <Route path="heritage-details/:id" element={<HeritageBooking />} />
            <Route path="payment" element={<PaymentPage />} />
            <Route path="booking-form" element={<BookingFormPage />} />
            <Route path="booking-details" element={<BookingDetailsPage />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="previous-booking" element={<PreviousBookings />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>

      {/* Toast Notifications */}
      <ToastContainer />
    </>
  );
};

export default CulturalHeritageRoutes;
